import './bootstrap';
import { forEachIfArray, q } from './utilities';
import {
  initBenefitsSwitcher,
  initCathaySwipers,
  initFlipCards,
  initMilesAndMoreBenefits,
  initMilesAndMoreLandingPage,
  initPartnerLinkFormPage,
  initPartnerDelinkFormPage,
  initPartnerPromoForm,
  initUnitedLandingPage,
} from './partners/partner';
import { initGlobalLanding } from './global-landing';
import { initCreativePage } from './creative-page';
import Splide from '@splidejs/splide';
// import Alpine from 'alpinejs';
//
// window.Alpine = Alpine;
//
// Alpine.start();

if (q('#united-landing-page')) {
  initUnitedLandingPage();
}

if (
  q('#partner-link-form-page') ||
  q('#cathay-link-form-page') ||
  q('#miles-and-more-account-link-form-page') ||
  q('#japan-airlines-account-link-form-page') ||
  q('#outside-account-link-form-page')
) {
  initPartnerLinkFormPage();
}

if (q('#partner-delink-form-page')) {
  initPartnerDelinkFormPage();
}

if (
  q('#partner-promo-register')
) {
  initPartnerPromoForm();
}

if (q('#global-landing-page')) {
  initGlobalLanding();
}

if (q('.cathay-page .benefit-cards') || q('.singapore-page .benefit-cards')) {
  initFlipCards();
}

if (q('#cathay-landing-page') || q('#cathay-signin-page') || q('#cathay-success-page')) {
  initCathaySwipers();
}

if (q('#singapore-landing-page')) {
  initBenefitsSwitcher();
  initFlipCards();
}

// if (q('#miles-and-more-landing-page')) {
//   initMilesAndMoreLandingPage();
// }

if (q('.miles-and-more-page .benefits-2')) {
  initMilesAndMoreBenefits();
}

if (q('.miles-and-more-page .earning-preference')) {
  document.addEventListener('DOMContentLoaded', () => {
    new Splide('.splide', {
      type: 'loop',
      autoWidth: true,
      arrows: false,
      pagination: false,
      autoplay: true,
    }).mount();

    function setCarouselOffset() {
      const earningPreferenceElWidth = q('.earning-preference').offsetWidth;
      const slideElWidth = q('.splide__slide')[0].offsetWidth;
      const gutterWidth = 10;
      let offsetWidth;
      if (window.innerWidth >= 576) {
        offsetWidth = (earningPreferenceElWidth - (2 * slideElWidth) - (gutterWidth * 4)) / 2;
      } else {
        offsetWidth = (earningPreferenceElWidth - slideElWidth - gutterWidth) / 2
      }
      q('.splide__list').style.left = offsetWidth + 'px';
    }
    setCarouselOffset();

    window.addEventListener('resize', setCarouselOffset);
  }); // DOMContentLoaded
}

if (q('.miles-and-more-page .brand-modules')) {
  function sizeBrandModuleImages() {
    let offset;
    if (window.innerWidth < 576) {
      offset = 60;
    } else {
      offset = 120;
    }
    const w1 = q('.table-marriott th.logo').offsetWidth;
    const w = window.innerWidth - offset - w1;
    forEachIfArray(q('.brand-modules .logos-wrap .mobile-wrap img'), (el) => {
      el.style.width = w + 'px';
    });
    forEachIfArray(q('.brand-modules .logos-wrap .mobile-wrap'), (el) => {
      el.style.width = w + 'px';
    });
  }

  $('#benefits-overview-modal').on('shown.bs.modal', () => {
    sizeBrandModuleImages();
  });
  $('#view-all-brands-modal').on('shown.bs.modal', () => {
    sizeBrandModuleImages();
  });

  window.addEventListener(('resize'), () => {
    sizeBrandModuleImages();
  });
}

if (q('.miles-and-more-page .table-miles-and-more')) {
  const tableWrapEl = q('.table-wrap.miles-and-more');
  const scrollLeftIcon = q('.caret-left');
  const scrollRightIcon = q('.caret-right');
  const stickyEls = q('.table-wrap.miles-and-more .sticky');

  function scrollPosition() {
    const scrollLeft = tableWrapEl.scrollLeft;
    const scrollWidth = tableWrapEl.scrollWidth;
    const offsetWidth = tableWrapEl.offsetWidth;

    if (scrollLeft === 0) {
      scrollLeftIcon.classList.add('hide');
      forEachIfArray(stickyEls, (el) => {
        el.classList.remove('bd');
      });
    } else {
      scrollLeftIcon.classList.remove('hide');
      forEachIfArray(stickyEls, (el) => {
        el.classList.add('bd');
      });
    }

    if (scrollLeft >= (scrollWidth - offsetWidth)) {
      scrollRightIcon.classList.add('hide');
    } else {
      scrollRightIcon.classList.remove('hide');
    }
  }
  scrollRightIcon.classList.remove('hide');
  scrollPosition();
  tableWrapEl.addEventListener('scroll', () => {
    scrollPosition();
  });
}

if (q('#creative-page')) {
  initCreativePage();
}
